export default __webpack_public_path__ + "static/media/51t.8da10577.jpg";